import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {EditDataMappingComponent} from '@features/data-mapping/components/edit-data-mapping/edit-data-mapping.component';
import {SelectDataMappingSourceDialogComponent} from '@features/data-mapping/components/select-data-mapping-source-dialog/select-data-mapping-source-dialog.component';
import {ApplyDataMappingDetailViewDialogComponent} from '@features/data-mapping/components/apply-data-mapping-detail-view-dialog/apply-data-mapping-detail-view-dialog.component';
import {SelectDataMappingDialogComponent} from '@features/data-mapping/components/select-data-mapping-dialog/select-data-mapping-dialog.component';
import {CreateDataMappingDialogComponent} from '@features/data-mapping/components/create-data-mapping-dialog/create-data-mapping-dialog.component';
import {PlatformToolDataMappingFolderViewComponent} from '@features/data-mapping/components/platform-tool-data-mapping-folder-view/platform-tool-data-mapping-folder-view.component';

// @dynamic
export class DataMappingDynamicComponentHelper {
  static components: any;

  static create(): void {
  }

  public static init() {
    if (DataMappingDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['EditDataMappingComponent'] = EditDataMappingComponent;
    components['SelectDataMappingSourceDialogComponent'] = SelectDataMappingSourceDialogComponent;
    components['ApplyDataMappingDetailViewDialogComponent'] = ApplyDataMappingDetailViewDialogComponent;
    components['SelectDataMappingDialogComponent'] = SelectDataMappingDialogComponent;
    components['CreateDataMappingDialogComponent'] = CreateDataMappingDialogComponent;
    components['PlatformToolDataMappingFolderViewComponent'] = PlatformToolDataMappingFolderViewComponent;
    DataMappingDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static getComponentArray(): any[] {
    DataMappingDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(DataMappingDynamicComponentHelper.components).forEach(key => {
      componentArray.push(DataMappingDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }

  public static register(key: string, component: any) {
    DataMappingDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
